module.exports = __webpack_public_path__ + "static/img/music-home-hover.48ee8a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/music-home-hover.png
// module id = bwFr
// module chunks = 0